var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgrammingSkills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.126,
    height: 19.301,
    viewBox: "0 0 24.126 19.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop-code",
    "data-name": "Icon awesome-laptop-code",
    d: "M480.713,3922.65h-19.3a2.416,2.416,0,0,1-2.413-2.413v-.6a.6.6,0,0,1,.6-.6h9.018a1.2,1.2,0,0,0,.366.824,1.22,1.22,0,0,0,.869.382h2.292a1.185,1.185,0,0,0,1.234-1.206h9.14a.6.6,0,0,1,.6.6v.6A2.416,2.416,0,0,1,480.713,3922.65Zm0-4.826h-19.3v-12.666a1.812,1.812,0,0,1,1.809-1.81H478.9a1.812,1.812,0,0,1,1.81,1.81v12.665Zm-16.893-12.065v9.65H478.3v-9.65Zm9.265,7.63a.6.6,0,0,1-.427-.177l-.426-.426a.606.606,0,0,1,0-.854l1.346-1.346-1.346-1.347a.6.6,0,0,1,0-.853l.426-.427a.6.6,0,0,1,.854,0l2.2,2.2a.606.606,0,0,1,0,.854l-2.2,2.2A.6.6,0,0,1,473.086,3913.389Zm-4.046,0a.6.6,0,0,1-.426-.177l-2.2-2.2a.6.6,0,0,1,0-.854l2.2-2.2a.6.6,0,0,1,.854,0l.426.426a.605.605,0,0,1,0,.854l-1.346,1.347,1.346,1.346a.6.6,0,0,1,0,.854l-.426.426A.6.6,0,0,1,469.04,3913.389Z",
    transform: "translate(-458.999 -3903.348)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingSkills);
export default __webpack_public_path__ + "static/media/programming-skills.d19983a9bee884277ffa4156796bcc0c.svg";
export { ForwardRef as ReactComponent };